export default "__VITE_ASSET__94a2cd8e__"